//@flow
import React from "react";
import fluxfix from "../../services/fluxfix";

// $FlowFixMe
import css from "./listenagain.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlayCircle, faPauseCircle, faSyncAlt } from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
import {Actions} from "../../services/actions";
import Store from "../../services/store";
import { Container } from "flux/utils";
import { AudioSource, SourceType } from "../audioplayer-v2/source";
import { roundDate } from "../../lib/rounddate";

type Props = {
  episode: Object,
  feature: Object,
};
type State = {
  store: Object,
};
class Episode extends React.Component<Props, State> {
  static getStores() {
    return [Store];
  }

  static calculateState(prevState) {
    return { store: Store.getState() };
  }

  // getURL(): string {
  //   return makeLanseURL(this.props.episode.audioRcid);
  //   // return window.LANSE_SERVER + this.props.episode.audioRcid + "/" + this.props.episode.audioRcid + ".m3u8";
  // }
  isCurrentMedia(): boolean {
    // console.log(window.LANSE_SERVER + this.props.episode.audioRcid + "/" + this.props.episode.audioRcid + ".m3u8");
    // console.log(PlayerActions.getRawSource())
    return this.props.episode.hlsURL === this.state.store.get("currentSrc")?.src;
  }

  handleClickIcon() {
    // console.log(this.props.feature)
    if (this.isCurrentMedia()) {
      Actions.togglePlay();
    } else {
      const src = new AudioSource();
      src.src = this.props.episode.hlsURL;
      src.id = this.props.episode.audioRcid;
      // src.description = this.props.episode.description;
      src.srctype = SourceType.HLS;
      // src.img = this.props.feature.image;
      src.isLiveStream = false;
      Actions.setCurrentSrc(src);
      Actions.setDesiredPlayState(true)
    }
  }

  render(): Object {
    // console.log(this.props.episode)
    const airDate = roundDate(moment(this.props.episode.airDate)).format("ddd Do MMM HH:mm");
    let duration = moment.duration(this.props.episode.durationSecs, "seconds").humanize();
    if (duration === "an hour") {
      duration = "1 hour";
    }
    const playState = this.state.store.get("playState");
    // const isBuffering = this.state.store.get("isBuffering");

    let icon = faPlayCircle;
    let spin = false;
    if (this.isCurrentMedia() && playState==="PLAYING") icon = faPauseCircle;
    if (this.isCurrentMedia() && playState==="BUFFERING") {
      icon = faSyncAlt;
      spin = true;
    }

    let availableFor = null;
    if (this.props.episode.listenAgainExpires) {
      const d = moment.duration(moment().diff(moment(this.props.episode.listenAgainExpires)));
      availableFor = <div className={css.episodeExpiry}>Available for: {d.humanize()}</div>;
    }

    const explicitIcon = this.props.episode.explicit ? <span className={css.explicit}>EXPLICIT</span> : null;
    // console.log(this.props.episode);
    const savedTime = Number(localStorage.getItem(this.props.episode.audioRcid + "_currentTime")) || 0;
    const savedDuration = Number(localStorage.getItem(this.props.episode.audioRcid + "_duration")) || 1;
    const percentCompleted = (100 * savedTime) / savedDuration;

    return (
      <div className={css.episode} style={{borderColor:this.props.feature.color}}>
        <div>
          <div className={css.epCol}>
            <div className={css.episodeDescription}>{this.props.episode.description}</div>

            <div className={css.episodeDuration}>
              {duration}
              {explicitIcon}
            </div>

            <div className={css.episodeBroadcastDate}>First broadcast {airDate}</div>
            {availableFor}
          </div>
          <div className={css.col}>
            <div className={css.episodePlayIcon} onClick={() => this.handleClickIcon()}>
              <FontAwesomeIcon icon={icon} spin={spin} />
            </div>
          </div>
        </div>
        {percentCompleted > 0 ? (
          <div className={css.durationBar}>
            <div style={{ width: percentCompleted + "%" }} />
          </div>
        ) : null}
      </div>
    );
  }
}
export default (Container.create(fluxfix.convert(Episode)): Object);
